import Tile from 'components/Sections/Tiles/Tile';

export default Tile;
